import { Typography } from "@mui/material";

import SettingsToggle, {
  SettingsToggleProps,
} from "@app/analytics/components/SettingsToggle";

import Stack, { Row } from "@rui/Stack";

interface SettingWithToggleProps extends SettingsToggleProps {
  title: string;
  description?: string;
}

/**
 * Same UI as the SettingAccordion, without expand / collapse capability
 */
const SettingWithToggle = ({
  title,
  description,
  onChange,
  checked,
  disabled,
  disabledTooltip,
}: SettingWithToggleProps) => {
  return (
    <Row justifyContent="space-between" spacing={1} paddingY={1} paddingX={0}>
      <Stack spacing={0.5}>
        <Typography variant="bodyPrimaryMed">{title}</Typography>
        {description && (
          <Typography variant="bodySecondaryReg" color="shades.neutral.500">
            {description}
          </Typography>
        )}
      </Stack>
      <SettingsToggle
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        disabledTooltip={disabledTooltip}
      />
    </Row>
  );
};
export default SettingWithToggle;
